// ─── KpiCard ──────────────────────────────────────────────────────────────────
//  Tile de indicador reutilizável: label + valor em destaque + subtítulo opcional.
//  C: tema (card, border, text, muted) — mesma forma usada nas páginas do módulo.

export function KpiCard({ label, value, sub, color, C }) {
  return (
    <div
      style={{
        background: C.card,
        border: `1px solid ${C.border}`,
        borderRadius: 14,
        padding: "16px 18px",
        display: "flex",
        flexDirection: "column",
        gap: 6,
        minWidth: 0,
      }}
    >
      <span style={{
        fontSize: 11, fontWeight: 700, color: C.muted,
        textTransform: "uppercase", letterSpacing: "0.06em",
      }}>
        {label}
      </span>
      <span style={{
        fontSize: 22, fontWeight: 800, color: color || C.text,
        lineHeight: 1.15, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
      }}>
        {value}
      </span>
      {sub && (
        <span style={{ fontSize: 11, color: C.muted }}>{sub}</span>
      )}
    </div>
  );
}

export function KpiRow({ items, C }) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
        gap: 14,
        maxWidth: "100%",
      }}
    >
      {items.map((item) => (
        <KpiCard key={item.label} C={C} {...item} />
      ))}
    </div>
  );
}
